import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const AnimatedBorder = ({ children, delay = 0, className = "", duration = 2 }) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const containerRef = useRef(null);

  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        const { width, height } = containerRef.current.getBoundingClientRect();
        setDimensions({ width, height });
      }
    };

    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return (
    <div ref={containerRef} className={`relative ${className}`}>
      {dimensions.width > 0 && (
        <svg
          className="absolute inset-0 w-full h-full pointer-events-none"
          style={{ zIndex: 10 }}
          width={dimensions.width}
          height={dimensions.height}
        >
          <motion.path
            d={`M 1 1 L ${dimensions.width - 1} 1 L ${dimensions.width - 1} ${dimensions.height - 1} L 1 ${dimensions.height - 1} Z`}
            fill="none"
            stroke="white"
            strokeWidth="1"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{
              duration: duration,
              delay: delay,
              ease: "easeInOut"
            }}
          />
        </svg>
      )}
      {children}
    </div>
  );
};

export default AnimatedBorder;